import { MouseEventHandler, useState } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { QUIZ_SUBJECT_RATING } from '~/types/homebaseQuiz.types'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

export default function CurriculumMappingQuizRatingItem({
  emoji,
  handleOnClick,
  ratingValue,
  isLoading,
  isSmallEmoji = false,
}: {
  emoji: string
  handleOnClick: (rating: number) => MouseEventHandler<HTMLDivElement>
  ratingValue: QUIZ_SUBJECT_RATING
  isLoading: boolean
  isSmallEmoji?: boolean
}): React.ReactElement {
  const [isClicked, setIsClicked] = useState(false)
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const isTablet = useCheckBreakpoint({ lt: Breakpoint.LG })
  const emojiSize = isMobile ? 45 : isTablet ? 80 : 100
  const size = isSmallEmoji ? emojiSize * 0.65 : emojiSize

  const onClick = (): void => {
    setIsClicked(true)
    setTimeout(() => {
      setIsClicked(false)
    }, 300)
  }

  return (
    <div
      className="flex flex-1 justify-center gap-2 md:gap-4 mt-8 text-white cursor-pointer"
      onClick={handleOnClick(ratingValue)}
    >
      <button
        className={`w-18 h-18 md:h-30 md:w-36 lg:w-44 lg:h-36 rounded-2 md:rounded-4 bg-black bg-opacity-20 flex items-center justify-center text-3xl transition-all duration-300 md:hover:scale-105 md:hover:border-2 md:hover:border-green ${
          isLoading ? 'cursor-wait' : 'cursor-pointer'
        } ${
          isClicked ? 'scale-105 border-2 border-green drop-shadow-lightgreen' : ''
        } flex flex-col items-center w-17 md:w-30`}
        onClick={onClick}
      >
        <ResponsiveImage
          alt={`rating ${ratingValue}`}
          height={size}
          imageClassName="flex"
          imageWidths="180"
          srcKey={emoji}
          width={size}
        />
      </button>
    </div>
  )
}
